<ng-container screenAnalytics="rpa-register">
    <div class="modal-header no-icon">
        <h3 class="modal-title">
            {{ authorityType.name }} {{ title }} Register -
            {{ displayableRegisterModeLookup[register.registerMode] }}
        </h3>
        <enhanced-help-switch></enhanced-help-switch>
        <button
            type="button"
            (click)="modal.hide()"
            aria-label="Close"
            class="close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <ngx-loading [show]="working"></ngx-loading>
    <div
        class="modal-body no-footer"
        [ngClass]="{ 'no-scroll': expandedSideSheet }"
    >
        <form [formGroup]="formGroup" novalidate>
            <div class="modal-body-content container-scroll">
                <enhanced-help componentName="rpa-register" [compact]="true">
                </enhanced-help>
                <div
                    class="side-sheet-table"
                    *ngIf="register.registerMode !== 'DISABLED'"
                >
                    <table class="table">
                        <thead>
                            <tr>
                                <th
                                    style="width: 70px"
                                    *ngIf="hasProfilePicture"
                                ></th>
                                <th class="sortable" style="width: 20%">
                                    <span (click)="sort('subjectName')">
                                        Name
                                        <ng-container
                                            *ngIf="sortList['subjectName']"
                                        >
                                            <span
                                                *ngIf="
                                                    sortList['subjectName']
                                                        .ascending
                                                "
                                                class="fa fa-sort-up"
                                            >
                                            </span>
                                            <span
                                                *ngIf="
                                                    !sortList['subjectName']
                                                        .ascending
                                                "
                                                class="fa fa-sort-down"
                                            >
                                            </span>
                                        </ng-container>
                                        <span
                                            *ngIf="!sortList['subjectName']"
                                            class="fal fa-sort"
                                        ></span>
                                    </span>
                                </th>
                                <th
                                    *ngIf="hasManagingOrganisation$ | async"
                                    style="width: 15%"
                                >
                                    Managing Organisation
                                </th>
                                <th style="width: 18%">
                                    <span> Maintenance Authority </span>
                                </th>
                                <th class="sortable" style="width: 15%">
                                    <span (click)="sort('startDate')">
                                        Start Date
                                        <ng-container
                                            *ngIf="sortList['startDate']"
                                        >
                                            <span
                                                *ngIf="
                                                    sortList['startDate']
                                                        .ascending
                                                "
                                                class="fa fa-sort-up"
                                            >
                                            </span>
                                            <span
                                                *ngIf="
                                                    !sortList['startDate']
                                                        .ascending
                                                "
                                                class="fa fa-sort-down"
                                            >
                                            </span>
                                        </ng-container>
                                        <span
                                            *ngIf="!sortList['startDate']"
                                            class="fal fa-sort"
                                        ></span>
                                    </span>
                                </th>
                                <th class="sortable" style="width: 15%">
                                    <span (click)="sort('endDate')">
                                        End Date
                                        <ng-container
                                            *ngIf="sortList['endDate']"
                                        >
                                            <span
                                                *ngIf="
                                                    sortList['endDate']
                                                        .ascending
                                                "
                                                class="fa fa-sort-up"
                                            >
                                            </span>
                                            <span
                                                *ngIf="
                                                    !sortList['endDate']
                                                        .ascending
                                                "
                                                class="fa fa-sort-down"
                                            >
                                            </span>
                                        </ng-container>
                                        <span
                                            *ngIf="!sortList['endDate']"
                                            class="fal fa-sort"
                                        ></span>
                                    </span>
                                </th>
                                <th class="sortable" style="width: 12%">
                                    <span (click)="sort('status')">
                                        Status
                                        <ng-container
                                            *ngIf="sortList['status']"
                                        >
                                            <span
                                                *ngIf="
                                                    sortList['status'].ascending
                                                "
                                                class="fa fa-sort-up"
                                            >
                                            </span>
                                            <span
                                                *ngIf="
                                                    !sortList['status']
                                                        .ascending
                                                "
                                                class="fa fa-sort-down"
                                            >
                                            </span>
                                        </ng-container>
                                        <span
                                            *ngIf="!sortList['status']"
                                            class="fal fa-sort"
                                        ></span>
                                    </span>
                                </th>
                                <th
                                    *ngFor="let check of checks"
                                    style="width: 8%"
                                >
                                    {{ check.name }}
                                </th>
                                <th
                                    *ngIf="authority.availableActions.canManage"
                                    class="actions right-buffer"
                                    style="border-bottom: none; width: 70px"
                                >
                                    <button
                                        type="button"
                                        class="btn btn-tertiary btn-sm"
                                        (click)="expandedSideSheet = true"
                                    >
                                        <span
                                            class="fa fa-ellipsis-h"
                                            tooltip="Customise the register condition columns"
                                            placement="left"
                                        ></span>
                                    </button>
                                </th>
                                <th
                                    *ngIf="
                                        !authority.availableActions.canManage
                                    "
                                ></th>
                            </tr>
                            <tr>
                                <th
                                    *ngIf="hasProfilePicture"
                                    style="width: 70px"
                                ></th>
                                <th style="width: 20%"></th>
                                <th
                                    *ngIf="hasManagingOrganisation$ | async"
                                    style="width: 15%"
                                ></th>
                                <th style="width: 18%"></th>
                                <th style="width: 15%; min-width: 15rem"></th>
                                <th style="width: 15%; min-width: 15rem"></th>
                                <th style="width: 12%">
                                    <select
                                        class="form-control"
                                        #filterStatus
                                        (change)="
                                            filterByStatus(filterStatus.value)
                                        "
                                    >
                                        <option [value]="'all'">(All)</option>
                                        <option
                                            *ngFor="let status of statuses"
                                            [value]="status.value"
                                        >
                                            {{ status.name }}
                                        </option>
                                    </select>
                                </th>
                                <th
                                    *ngFor="let check of checks"
                                    style="width: 8%"
                                ></th>
                                <th
                                    *ngIf="
                                        authority.availableActions.canManage ||
                                        authority.availableActions
                                            .canManageEntries
                                    "
                                    style="width: 70px"
                                ></th>
                                <th
                                    *ngIf="
                                        !(
                                            authority.availableActions
                                                .canManage ||
                                            authority.availableActions
                                                .canManageEntries
                                        )
                                    "
                                ></th>
                            </tr>
                        </thead>
                        <tbody formGroupName="edit">
                            <tr *ngFor="let entry of entries">
                                <td *ngIf="hasProfilePicture">
                                    <profile-picture
                                        [personId]="entry?.subjectId"
                                        [managingOrganisationId]="
                                            organisationId
                                        "
                                        [width]="35"
                                        [height]="35"
                                    >
                                    </profile-picture>
                                </td>
                                <td>
                                    <a (click)="showEntry(entry)">{{
                                        entry.subjectName
                                    }}</a>
                                </td>
                                <td *ngIf="hasManagingOrganisation$ | async">
                                    <editable
                                        [disabled]="working"
                                        [confirmationButtons]="true"
                                        [cancelOnClickOutside]="false"
                                        [initialContext]="{
                                            managingOrganisationId:
                                                entry.managingOrganisationId
                                        }"
                                        (update)="
                                            changeManagingOrganisation(
                                                entry,
                                                $event
                                            )
                                        "
                                    >
                                        <ng-template
                                            viewMode
                                            let-context="context"
                                        >
                                            {{
                                                (
                                                    availableOrganisations$
                                                    | async
                                                    | findById
                                                        : entry.managingOrganisationId
                                                )?.name
                                            }}
                                        </ng-template>
                                        <ng-template
                                            editMode
                                            let-context="context"
                                        >
                                            <ng-select
                                                appendTo="body"
                                                [items]="
                                                    availableOrganisations$
                                                        | async
                                                "
                                                bindLabel="name"
                                                bindValue="id"
                                                placeholder="Managing Organisation"
                                                [clearable]="false"
                                                [(ngModel)]="
                                                    context.managingOrganisationId
                                                "
                                                [ngModelOptions]="{
                                                    standalone: true
                                                }"
                                            ></ng-select>
                                        </ng-template>
                                    </editable>
                                </td>
                                <td>
                                    <editable
                                        [disabled]="working"
                                        [confirmationButtons]="true"
                                        [cancelOnClickOutside]="false"
                                        [initialContext]="{
                                            maintenanceAuthorityId:
                                                entry.maintenanceAuthority?.id
                                        }"
                                        (update)="
                                            updateRpaMaintenanceAuthority(
                                                entry,
                                                $event
                                            )
                                        "
                                    >
                                        <ng-template
                                            viewMode
                                            let-context="context"
                                        >
                                            {{
                                                entry.maintenanceAuthority
                                                    | formatMaintenanceAuthority
                                                        : authority
                                            }}
                                        </ng-template>
                                        <ng-template
                                            editMode
                                            let-context="context"
                                        >
                                            <ng-select
                                                appendTo="body"
                                                [items]="availableAuthorities"
                                                bindLabel="name"
                                                bindValue="id"
                                                placeholder="Maintenance Authority"
                                                [clearable]="false"
                                                [(ngModel)]="
                                                    context.maintenanceAuthorityId
                                                "
                                                [ngModelOptions]="{
                                                    standalone: true
                                                }"
                                            >
                                                <ng-template
                                                    ng-option-tmp
                                                    let-item="item"
                                                >
                                                    {{ item.name }}
                                                </ng-template>
                                                <ng-template
                                                    ng-label-tmp
                                                    let-item="item"
                                                >
                                                    {{ item.name }}
                                                </ng-template>
                                            </ng-select>
                                        </ng-template>
                                    </editable>
                                </td>
                                <td
                                    [class.has-error]="
                                        hasError('add.subjectId')
                                    "
                                >
                                    <div
                                        *ngIf="entry.editable"
                                        class="input-group"
                                    >
                                        <input
                                            class="form-control"
                                            #editStartDate="bsDatepicker"
                                            bsDatepicker
                                            formControlName="startDate"
                                        />
                                        <span
                                            class="input-group-addon btn-default"
                                            (click)="editStartDate.toggle()"
                                            [attr.aria-expanded]="
                                                editStartDate.isOpen
                                            "
                                        >
                                            <i
                                                class="glyphicon glyphicon-calendar"
                                                style="cursor: pointer"
                                            ></i>
                                        </span>
                                    </div>
                                    <validation-messages
                                        *ngIf="entry.editable"
                                        [control]="edit.controls.startDate"
                                    ></validation-messages>
                                    <span *ngIf="!entry.editable">{{
                                        entry.startDate | formatDate : null:true
                                    }}</span>
                                </td>
                                <td>
                                    <div
                                        *ngIf="entry.editable"
                                        class="input-group"
                                    >
                                        <input
                                            class="form-control"
                                            #editEndDate="bsDatepicker"
                                            bsDatepicker
                                            formControlName="endDate"
                                            [minDate]="
                                                formGroup.get('edit.startDate')
                                                    .value
                                            "
                                        />
                                        <span
                                            class="input-group-addon btn-default"
                                            (click)="editEndDate.toggle()"
                                            [attr.aria-expanded]="
                                                editEndDate.isOpen
                                            "
                                        >
                                            <i
                                                class="glyphicon glyphicon-calendar"
                                                style="cursor: pointer"
                                            ></i>
                                        </span>
                                    </div>
                                    <validation-messages
                                        *ngIf="entry.editable"
                                        [control]="edit.controls.endDate"
                                    ></validation-messages>
                                    <span *ngIf="!entry.editable">{{
                                        entry.endDate | formatDate : null : true
                                    }}</span>
                                </td>
                                <td
                                    style="padding: 10px 0"
                                    [class.has-error]="
                                        hasError('add.subjectId')
                                    "
                                >
                                    <ng-select
                                        *ngIf="entry.editable"
                                        [items]="statuses"
                                        bindLabel="name"
                                        bindValue="value"
                                        appendTo="body"
                                        formControlName="statusSource"
                                        [clearable]="false"
                                        placeholder="Status of this record"
                                    >
                                    </ng-select>
                                    <span *ngIf="!entry.editable">
                                        <register-status-display
                                            [status]="
                                                checkResults[entry.id]?.status
                                            "
                                            [statusSource]="entry.statusSource"
                                        ></register-status-display>
                                    </span>
                                </td>
                                <td *ngFor="let check of checks">
                                    <ng-container
                                        *ngIf="
                                            findCheckResult(
                                                entry,
                                                check
                                            ) as checkResult
                                        "
                                    >
                                        <span
                                            *ngIf="checkResult.popover != null"
                                            #pop="bs-popover"
                                            [popover]="authorityCheckTemplate"
                                            container="body"
                                            [outsideClick]="true"
                                            placement="bottom"
                                            (click)="openPopover(pop)"
                                            [innerHtml]="checkResult.content"
                                            style="cursor: pointer"
                                        >
                                        </span>
                                        <action-required
                                            *ngIf="
                                                mappedExpiries != null &&
                                                mappedExpiries[entry.id] !=
                                                    null &&
                                                mappedExpiries[entry.id][
                                                    checkResult.checkId
                                                ] != null &&
                                                mappedExpiries[entry.id][
                                                    checkResult.checkId
                                                ].expiryStatus === 'UPCOMING'
                                            "
                                            [noPopover]="true"
                                            tooltipText="This element has an upcoming expiry"
                                        ></action-required>
                                        <action-required
                                            *ngIf="
                                                mappedExpiries != null &&
                                                mappedExpiries[entry.id] !=
                                                    null &&
                                                mappedExpiries[entry.id][
                                                    checkResult.checkId
                                                ] != null &&
                                                mappedExpiries[entry.id][
                                                    checkResult.checkId
                                                ].expiryStatus === 'EXPIRED'
                                            "
                                            [noPopover]="true"
                                            tooltipText="This element has expired"
                                        ></action-required>
                                        <ng-template #authorityCheckTemplate>
                                            <organisation-authority-check
                                                [authorityId]="
                                                    checkResult.verificationEntityId
                                                "
                                                [managingOrganisationId]="
                                                    managingOrganisationId
                                                "
                                                [type]="check.conditionType"
                                                [details]="checkResult.details"
                                                [description]="
                                                    check.description
                                                "
                                                [checkDetails]="
                                                    checkResult.activity
                                                "
                                                [registerConditionsHandler]="
                                                    rpaRegister
                                                "
                                                [checkName]="check.name"
                                                [acknowledgedAttachment]="
                                                    findCheckAttachment(
                                                        check.name
                                                    )
                                                "
                                                (onCheckUpdated)="
                                                    onCheckUpdated()
                                                "
                                                register="RPA"
                                            >
                                            </organisation-authority-check>
                                        </ng-template>
                                        <span
                                            *ngIf="checkResult.popover == null"
                                            [innerHtml]="checkResult.content"
                                        ></span>
                                    </ng-container>
                                </td>
                                <td
                                    *ngIf="
                                        authority.availableActions.canManage ||
                                        authority.availableActions
                                            .canManageEntries
                                    "
                                    class="actions"
                                >
                                    <div *ngIf="entry.editable" class="inline">
                                        <button
                                            class="btn btn-sm btn-primary"
                                            type="button"
                                            (click)="updateConcreteEntry()"
                                            [disabled]="working || edit.invalid"
                                        >
                                            Save
                                        </button>
                                        <button
                                            class="btn btn-sm"
                                            type="button"
                                            (click)="cancelEditMode(entry)"
                                        >
                                            Cancel
                                        </button>
                                    </div>

                                    <div *ngIf="!entry.editable" class="inline">
                                        <button
                                            class="btn btn-sm btn-tertiary"
                                            *ngIf="entry.id"
                                            [disabled]="editing != null"
                                            (click)="showEditMode(entry)"
                                        >
                                            <span
                                                class="fal fa-pencil-alt"
                                            ></span>
                                        </button>
                                        <button
                                            class="btn btn-sm btn-tertiary btn-delete"
                                            *ngIf="entry.id"
                                            [disabled]="editing != null"
                                            (click)="deleteConcreteEntry(entry)"
                                        >
                                            <span
                                                class="fal fa-trash-alt"
                                            ></span>
                                        </button>
                                    </div>
                                </td>
                                <td
                                    *ngIf="
                                        !(
                                            authority.availableActions
                                                .canManage ||
                                            authority.availableActions
                                                .canManageEntries
                                        )
                                    "
                                ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div
                    *ngIf="
                        register.registerMode !== 'DISABLED' &&
                        (authority.availableActions.canManage ||
                            authority.availableActions.canNominateEntries) &&
                        (addCandidateOrganisations$ | async)?.length > 1
                    "
                    class="horizontal-container gap bottom-buffer vertical-align"
                >
                    <label class="control-label">Source Organisation</label>
                    <ng-select
                        [items]="addCandidateOrganisations$ | async"
                        bindLabel="name"
                        bindValue="id"
                        appendTo="body"
                        [clearable]="false"
                        [ngModel]="selectedCandidateOrganisationId"
                        (ngModelChange)="onCandidateOrganisationChanged($event)"
                        [ngModelOptions]="{ standalone: true }"
                        style="min-width: 200px"
                    ></ng-select>
                </div>
                <div
                    class="horizontal-container gap"
                    *ngIf="
                        register.registerMode !== 'DISABLED' &&
                        (authority.availableActions.canManage ||
                            authority.availableActions.canNominateEntries)
                    "
                    formGroupName="add"
                >
                    <div
                        class="form-group"
                        style="flex: 2"
                        [class.has-error]="hasError('add.subjectId')"
                    >
                        <ng-select
                            [items]="candidates"
                            bindLabel="name"
                            bindValue="id"
                            appendTo="body"
                            [clearable]="false"
                            [multiple]="true"
                            formControlName="subjectId"
                            placeholder="The RPA to add to the register"
                            [readonly]="working"
                        >
                        </ng-select>
                    </div>
                    <div
                        class="form-group"
                        style="flex: 1"
                        [class.has-error]="hasError('add.startDate')"
                    >
                        <div class="input-group">
                            <input
                                class="form-control"
                                #startDatePicker="bsDatepicker"
                                bsDatepicker
                                formControlName="startDate"
                                [readonly]="working"
                            />
                            <span
                                class="input-group-addon btn-default"
                                (click)="startDatePicker.toggle()"
                                [attr.aria-expanded]="startDatePicker.isOpen"
                            >
                                <i
                                    class="glyphicon glyphicon-calendar"
                                    style="cursor: pointer"
                                ></i>
                            </span>
                        </div>
                        <validation-messages
                            [control]="add.controls.startDate"
                        ></validation-messages>
                    </div>
                    <div
                        class="form-group"
                        style="flex: 1"
                        [class.has-error]="hasError('add.endDate')"
                    >
                        <div class="input-group">
                            <input
                                class="form-control"
                                #endDatePicker="bsDatepicker"
                                bsDatepicker
                                formControlName="endDate"
                                [minDate]="formGroup.get('add.startDate').value"
                                [readonly]="working"
                            />
                            <span
                                class="input-group-addon btn-default"
                                (click)="endDatePicker.toggle()"
                                [attr.aria-expanded]="endDatePicker.isOpen"
                            >
                                <i
                                    class="glyphicon glyphicon-calendar"
                                    style="cursor: pointer"
                                ></i>
                            </span>
                        </div>
                        <validation-messages
                            [control]="add.controls.endDate"
                        ></validation-messages>
                    </div>
                    <div
                        *ngIf="
                            authority.availableActions.canManage ||
                            authority.availableActions.canManageEntries
                        "
                        class="form-group"
                        style="flex: 1"
                        [class.has-error]="hasError('add.statusSource')"
                    >
                        <ng-select
                            [items]="statuses"
                            bindLabel="name"
                            bindValue="value"
                            appendTo="body"
                            formControlName="statusSource"
                            [clearable]="false"
                            placeholder="Status of this record"
                            [readonly]="working"
                        >
                        </ng-select>
                    </div>
                    <div>
                        <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            [disabled]="working || add.invalid"
                            (click)="createConcreteEntry()"
                        >
                            {{
                                authority.availableActions.canManage ||
                                authority.availableActions.canManageEntries
                                    ? 'Save'
                                    : 'Nominate'
                            }}
                        </button>
                    </div>
                </div>
                <div
                    *ngIf="register.registerMode === 'DISABLED' && !working"
                    class="vertical-container fill"
                >
                    <empty
                        componentName="rpa-register-disabled"
                        [disabledState]="true"
                    >
                        <button
                            type="button"
                            class="btn btn-default top-buffer"
                            (click)="expandedSideSheet = true"
                        >
                            Edit register settings
                        </button>
                    </empty>
                </div>

                <registers-side-sheet
                    [expand]="expandedSideSheet"
                    [registerConditionsHandler]="registerConditionsHandler"
                    (conditionsChanged)="onConditionsChanged()"
                    (closeSideSheet)="expandedSideSheet = false"
                >
                </registers-side-sheet>
            </div>
        </form>
    </div>
</ng-container>
